export default __webpack_public_path__ + "static/media/logo.725ffc3c.jpeg";